import dayjs from "dayjs"

export const setUTCDate = (dateString) => {
  const result = [];
  dateString?.forEach((item) => {
    const [datePart, timePart] = item?.split(" ");
    const [hour, minute, second] = timePart.split(":").map(Number);
    const date = new Date(item);
    date.setUTCHours(hour, minute, second, 0);
    result.push(date.toISOString());
  });
  return result;
};

export function generatedISOFormatDateString (date) {
  // console.log(date)
  const currentDate =  date.toLocaleString("en-US", { hour12: false });
  const [month, day, rem] = currentDate.split("/");
  const [year, time] = rem?.split(", ");
  const [hour, minute, seconds] = time.split(":");

  const formattedDate = `${year}-${month}-${day}T${hour}:${minute}:${seconds}.000Z`

  return formattedDate
}

function parseCustomDateString(dateString) {
  console.log(dateString);
  const [day, month, year, time, meridian] = dateString.split(/[\s,:/]+/);
  let [hours, minutes, seconds] = time.split(':').map(Number);

  // Convert 12-hour format to 24-hour format
  if (meridian.toLowerCase() === 'pm' && hours !== 12) {
    hours += 12;
  } else if (meridian.toLowerCase() === 'am' && hours === 12) { 
    hours = 0;
  }

  return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
}

export function calculateDateRangeFromDate(date, minutesBefore, minutesAfter) { 
  // console.log(dateString)
  // const date = parseCustomDateString(dateString) 
  // console.log(date)

  const fromDate = new Date(date);
  const toDate = new Date(date); 
  console.log(fromDate)

  // console.log(fromDate)
  // console.log(toDate)

  const fromMin = fromDate.getMinutes() - minutesBefore;
  const toMin = toDate.getMinutes() + minutesAfter;

  fromDate.setMinutes(fromMin);
  toDate.setMinutes(toMin);

  // Set current hours
  // const currentHours = date.getHours();
  // fromDate.setUTCHours(currentHours);
  // toDate.setUTCHours(currentHours);
  console.log(fromDate)

  const formattedFromDate = generatedISOFormatDateString(fromDate)
  const formattedToDate = generatedISOFormatDateString(toDate)

  return {
    from: formattedFromDate,
    to: formattedToDate,
  };
}

export function filterDataByTimeRange(data, timeRangeMinutes) {j
  const timeRangeMilliseconds = timeRangeMinutes * 60 * 1000;
  const currentTime = new Date();

  currentTime.setUTCHours(currentTime.getHours());
  currentTime.setUTCMinutes(currentTime.getMinutes());
  currentTime.setUTCSeconds(currentTime.getSeconds());
  currentTime.setUTCMilliseconds(currentTime.getMilliseconds());

  return data.filter((item) => {
    const itemTime = new Date(item.CreatedON);
    // if range is 15 filter the last 15 mins data
    return currentTime - itemTime <= timeRangeMilliseconds;
  });
}

export function groupDataByInterval(data, inter, period, date) {
  const groupedData = {};
  const firstSelected = data[0]

  const firstRecordCreatedONArray = [];
  const chartArray = [];

  let intervalInMilliseconds;

  switch (period) {
    case "month":
      intervalInMilliseconds = inter * 30.44 * 24 * 60 * 60 * 1000; // Months
      break;
    case "week":
      intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Weeks
      break;
    case "day":
      intervalInMilliseconds = inter * 24 * 60 * 60 * 1000; // Days
      break;
    case "min":
      intervalInMilliseconds = inter * 60 * 1000; // Minutes
      break;
    default:
      throw new Error("Invalid period");
  }

  // let intervalStartTime = new Date(data[0].createdON).getTime()
  let intervalStartTime = new Date(date).getTime()
  let startTime = new Date(intervalStartTime)


  // group the item based on meter name and interval
  data?.forEach((item) => {
    const timestamp = new Date(item.createdON)
    // const intervalKey = new Date(
    //   Math.floor(timestamp / intervalInMilliseconds) * intervalInMilliseconds
    // ).toLocaleString()
    if(timestamp > startTime){
      startTime = new Date(new Date(startTime).getTime()+intervalInMilliseconds)
    }

    const intervalKey = new Date(startTime).toLocaleString()
    const intervalDate = new Date(startTime - intervalInMilliseconds).toLocaleString()

    if (!groupedData[item.metername]) {
      groupedData[item.metername] = {};
    }

    if (!groupedData[item.metername][intervalKey]) {
      groupedData[item.metername][intervalKey] = {
        records: [],
      };
    }

    groupedData[item.metername][intervalKey]?.records.push({
      Cumulative: item.cumulative,
    });
    if (item.meterid === firstSelected.meterid && groupedData[item.metername][intervalKey].records.length === 1) {
      console.log(groupedData[item.metername][intervalKey])
      if(!firstRecordCreatedONArray.includes(intervalDate)){
        firstRecordCreatedONArray.push(intervalDate);
      }
    }
  });
  // calculate the column value and push into specific array
  for (const metername in groupedData) {
    const meterValues = [];

    for (const intervalKey in groupedData[metername]) {
      const records = groupedData[metername][intervalKey].records;
      const firstRecord = records[0];
      const lastRecord = records[records.length - 1];

      if (!groupedData[metername][intervalKey].finalValues) {
        groupedData[metername][intervalKey].finalValues = {};
      }
      groupedData[metername][intervalKey].finalValues.Cumulative =
        Math.abs(firstRecord?.Cumulative - lastRecord?.Cumulative);

      // Push cumulative value into meterValues
      meterValues.push(groupedData[metername][intervalKey].finalValues.Cumulative);
    }
    // Push an object into chartArray for each meterName
    chartArray.push({
      name: metername,
      data: meterValues,
    });
  }
  console.log(chartArray)

  console.log(groupedData)
  console.log(firstRecordCreatedONArray)
  return { chartArray, firstRecordCreatedONArray };
}


export function roundToTwoDecimalPlaces(number) {
  // Round the number to 2 decimal places using mathematical operations
  let roundedNumber = Math.round(number * 100) / 100;

  // Convert the rounded number to a string
  let roundedString = roundedNumber.toString();

  // Ensure that there are always 2 decimal places by appending zeros if needed
  // if (!roundedString.includes(".")) {
  //   roundedString += ".00";
  // } else if (roundedString.split(".")[1].length === 1) {
  //   roundedString += "0";
  // }
  
  return roundedString;
}

export const roundOffValue = (value) => {
  return Math.round(value);
};




export function groupDataByIntervalRhAndTemp(data, inter, period, date) {
  const groupedData = {};
  const firstSelected = data[0]

  const firstRecordCreatedONArray = [];
  const chartArray = [];

  let intervalInMilliseconds;

  switch (period) {
    case "month":
      intervalInMilliseconds = inter * 30.44 * 24 * 60 * 60 * 1000; // Months
      break;
    case "week":
      intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Weeks
      break;
    case "day":
      intervalInMilliseconds = inter * 24 * 60 * 60 * 1000; // Days
      break;
    case "min":
      intervalInMilliseconds = inter * 60 * 1000; // Minutes
      break;
    default:
      throw new Error("Invalid period");
  }

  // let intervalStartTime = new Date(data[0].createdON).getTime()
  let intervalStartTime = new Date(date).getTime()
  let startTime = new Date(intervalStartTime)

  console.log(data)


  // group the item based on meter name and interval
  data?.forEach((item) => {
    const timestamp = new Date(item.createdON)
    // const intervalKey = new Date(
    //   Math.floor(timestamp / intervalInMilliseconds) * intervalInMilliseconds
    // ).toLocaleString()
    if(timestamp > startTime){
      startTime = new Date(new Date(startTime).getTime()+intervalInMilliseconds)
    }

    const intervalKey = new Date(startTime).toLocaleString()
    const intervalDate = new Date(startTime - intervalInMilliseconds).toLocaleString()

    if (!groupedData[item.metername]) {
      groupedData[item.metername] = {};
    }
    console.log(groupedData)

    if (!groupedData[item.metername][intervalKey]) {
      groupedData[item.metername][intervalKey] = {
        records: [],
      };
    }

    groupedData[item.metername][intervalKey]?.records.push({
      rh: item.rh,
    });
    console.log(groupedData)
    if (item.meterid === firstSelected.meterid && groupedData[item.metername][intervalKey].records.length === 1) {
      console.log(groupedData[item.metername][intervalKey])
      if(!firstRecordCreatedONArray.includes(intervalDate)){
        firstRecordCreatedONArray.push(intervalDate);
      }
    }
  });
  // calculate the column value and push into specific array
  for (const metername in groupedData) {
    const meterValues = [];

    for (const intervalKey in groupedData[metername]) {
      const records = groupedData[metername][intervalKey].records;
      const firstRecord = records[0];
      const lastRecord = records[records.length - 1];

      if (!groupedData[metername][intervalKey].finalValues) {
        groupedData[metername][intervalKey].finalValues = {};
      }
      groupedData[metername][intervalKey].finalValues.rh =
        Math.abs(firstRecord?.rh - lastRecord?.rh);

      // Push rh value into meterValues
      meterValues.push(groupedData[metername][intervalKey].finalValues.rh);
    }
    // Push an object into chartArray for each meterName
    chartArray.push({
      name: metername,
      data: meterValues,
    });
  } 
  console.log(chartArray)

  console.log(groupedData)
  console.log(firstRecordCreatedONArray) 
  return { chartArray, firstRecordCreatedONArray };
}







// export function groupDataByInterval(data, inter, period, date) {
//   const groupedData = {};
//   const chartArray = [];

//   let intervalInMilliseconds;

//   // Set the interval in milliseconds based on the period
//   switch (period) {
//     case "month":
//       intervalInMilliseconds = inter * 30.44 * 24 * 60 * 60 * 1000; // Approximate month length
//       break;
//     case "week":
//       intervalInMilliseconds = inter * 7 * 24 * 60 * 60 * 1000; // Weeks
//       break;
//     case "day":
//       intervalInMilliseconds = inter * 24 * 60 * 60 * 1000; // Days
//       break;
//     case "min":
//       intervalInMilliseconds = inter * 60 * 1000; // Minutes
//       break;
//     default:
//       throw new Error("Invalid period");
//   }

//   let startTime = new Date(date).getTime();

//   // Group data by interval and meter name
//   data.forEach(item => {
//     const timestamp = new Date(item.createdON).getTime();

//     if (timestamp > startTime) {
//       // Shift the interval start if the timestamp exceeds the current interval
//       startTime = new Date(startTime + intervalInMilliseconds).getTime();
//     }

//     const intervalKey = new Date(startTime).toLocaleString();

//     // Initialize the meter if not present
//     if (!groupedData[item.metername]) {
//       groupedData[item.metername] = {};
//     }

//     // Initialize the interval group if not present
//     if (!groupedData[item.metername][intervalKey]) {
//       groupedData[item.metername][intervalKey] = {
//         flowRateRecords: [],
//         cumulativeRecords: [],
//       };
//     }

//     // Add the flowRate and cumulative data to the respective records
//     groupedData[item.metername][intervalKey].flowRateRecords.push(item.flowRate);
//     groupedData[item.metername][intervalKey].cumulativeRecords.push(item.cumulative);
//   });

//   // Process grouped data to calculate the aggregated flowRate and cumulative differences
//   for (const metername in groupedData) {
//     const flowRateValues = [];
//     const cumulativeValues = [];

//     for (const intervalKey in groupedData[metername]) {
//       const flowRateRecords = groupedData[metername][intervalKey].flowRateRecords;
//       const cumulativeRecords = groupedData[metername][intervalKey].cumulativeRecords;

//       // Average flowRate over the interval
//       const avgFlowRate = flowRateRecords.reduce((sum, val) => sum + val, 0) / flowRateRecords.length;

//       // Calculate cumulative difference
//       const firstCumulative = cumulativeRecords[0];
//       const lastCumulative = cumulativeRecords[cumulativeRecords.length - 1];
//       const cumulativeDifference = Math.abs(firstCumulative - lastCumulative);

//       // Push the calculated values into the respective arrays
//       flowRateValues.push(avgFlowRate);
//       cumulativeValues.push(cumulativeDifference);
//     }

//     // Push the data for this meter into the chart array
//     chartArray.push({
//       name: `${metername} - FlowRate`,
//       data: flowRateValues,
//     });
//     chartArray.push({
//       name: `${metername} - Cumulative`,
//       data: cumulativeValues,
//     });
//   }

//   console.log(chartArray);
//   return chartArray;
// }

// // Example usage
// const data = [
//   {
//     flowRate: 4,
//     cumulative: 3553209,
//     createdON: '2023-10-01T02:15:38.287',
//     sitename: 'M30',
//     meterid: 75,
//     metername: 'Air blower-1'
//   },
//   // Add all other data points here...
// ];

// const inter = 1; // Example interval
// const period = "day"; // Example period (day, week, month, min)
// const date = '2023-10-01T02:00:00.000'; // Starting date for intervals

// const result = groupDataByInterval(data, inter, period, date);

// console.log(result);
